/**
 * TermsPage — public terms of use for omniforce.dev.
 *
 * Honest early-stage scaffold; same caveat as PrivacyPage — replace
 * with counsel-reviewed copy before onboarding any external user
 * data or paid customers.
 */
import * as React from "react";
import { LandingNav } from "@/components/landing/LandingNav";
import { LandingFooter } from "@/components/landing/LandingFooter";
import "@/components/landing/landing.css";

export function TermsPage() {
  const [theme, setTheme] = React.useState<"dark" | "light">("dark");

  React.useEffect(() => {
    document.title = "Terms · Omniforce";
  }, []);

  return (
    <div className="landing" data-theme={theme}>
      <LandingNav
        onThemeToggle={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
        theme={theme}
      />
      <main>
        <section className="section">
          <div className="container" style={{ maxWidth: 760 }}>
            <div className="eyebrow">Legal</div>
            <h1 className="section__title" style={{ marginTop: 8 }}>
              Terms of Use
            </h1>
            <p style={{ color: "var(--fg-muted)", marginTop: 8 }}>
              Last updated: {new Date().toISOString().slice(0, 10)}
            </p>

            <h2 style={{ marginTop: 40 }}>About this site</h2>
            <p>
              omniforce.dev is the public marketing site for Omniforce, the
              maker of Omni — The Real Jarvis. You can browse it freely. By
              continuing to use the site you agree to the points below.
            </p>

            <h2 style={{ marginTop: 32 }}>Use of the site</h2>
            <p>
              Don't try to break the site, scrape it at unreasonable rates,
              impersonate Omniforce, or use the content in a way that would
              mislead other people about who built it.
            </p>

            <h2 style={{ marginTop: 32 }}>Content & code</h2>
            <p>
              Omni's open-source codebase is licensed separately under the MIT
              License at its repository. The marketing copy, illustrations and
              brand assets on this site are © Omniforce — please don't
              repurpose them without permission.
            </p>

            <h2 style={{ marginTop: 32 }}>No warranty</h2>
            <p>
              omniforce.dev and the Omni open-source project are provided "as
              is" without warranty of any kind. We work hard to keep things
              accurate and online, but we can't promise zero downtime or
              error-free content.
            </p>

            <h2 style={{ marginTop: 32 }}>Contact</h2>
            <p>
              Questions, complaints, or partnership conversations:{" "}
              <a href="mailto:omanandswami2005@gmail.com">
                omanandswami2005@gmail.com
              </a>
              .
            </p>

            <h2 style={{ marginTop: 32 }}>Changes</h2>
            <p>
              We'll revise these terms as the product matures. The "Last
              updated" date at the top reflects the current version.
            </p>
          </div>
        </section>
        <LandingFooter />
      </main>
    </div>
  );
}
